import { Constructor } from '@angular/cdk/table';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { compareArrays } from '../utils/array-utils';

type WithPrimaryColourFormSectionType = {
  _initPrimaryColour(primaryColour: string): void;
  _initPrimaryColourValueChanges(
    getPreviousPrimaryColourValue: () => string | null
  ): void;
  _buildPrimaryColour(): string;
};

type PrimaryColourFormSerectionRequirementsBase = {
  form: FormGroup;
  FORM_PATHS: {
    PRIMARY_COLOUR_HEX: () => string;
  };
  destroy$: Subject<boolean>;
};

export function WithPrimaryColourFormSection<
  TBase extends Constructor<PrimaryColourFormSerectionRequirementsBase>
>(
  baseClass: TBase
): {
  new (...args: any[]): WithPrimaryColourFormSectionType;
  prototype: WithPrimaryColourFormSectionType;
} & TBase {
  return class WithPrimaryColourFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initPrimaryColour(primaryColour: string): void {
      this.form
        .get(this.FORM_PATHS.PRIMARY_COLOUR_HEX())
        .setValue(primaryColour);
    }

    _initPrimaryColourValueChanges(
      getPreviousPrimaryColourValue: () => string | null
    ): void {
      this.form
        .get(this.FORM_PATHS.PRIMARY_COLOUR_HEX())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousPrimaryColourValue()) {
              this.form
                .get(this.FORM_PATHS.PRIMARY_COLOUR_HEX())
                .markAsPristine();
            }
          },
        });
    }

    _buildPrimaryColour(): string {
      return this.form.get(this.FORM_PATHS.PRIMARY_COLOUR_HEX()).value;
    }
  };
}
